"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureEnabled = exports.setFeatureFlags = void 0;
const featureFlags = {};
function setFeatureFlags(flags) {
    Object.assign(featureFlags, flags);
}
exports.setFeatureFlags = setFeatureFlags;
function isFeatureEnabled(flag) {
    return featureFlags[flag] === 'on';
}
exports.isFeatureEnabled = isFeatureEnabled;
//# sourceMappingURL=feature-flags.js.map